import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserOrganisation } from '../../app/ApiGen';
import { OrganisationState } from './types';

const initialState: OrganisationState = {
  loading: false,
  current: undefined,
};

const organisationSlice = createSlice({
  name: 'organisationSlice',
  initialState,
  reducers: {
    setCurrentOrganisationAction: (
      state: OrganisationState,
      action: PayloadAction<{ current: UserOrganisation | undefined }>,
    ): OrganisationState => ({
      ...state,
      loading: false,
      current: action.payload.current,
    }),
    changeCurrentOrganisationAction: (
      state: OrganisationState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- This is required to pass the slug to the saga
      _: PayloadAction<{ slug: string }>,
    ): OrganisationState => ({
      ...state,
      loading: true,
      current: undefined,
    }),
    clearCurrentOrganisationAction: (state: OrganisationState): OrganisationState => ({
      ...state,
      loading: false,
      current: undefined,
    }),
  },
});

export const { actions: organisationActions, reducer: organisationReducers } = organisationSlice;
